module.exports = __webpack_public_path__ + "static/media/Bettwäsche_.52f676b4.png";